import { useQuery } from "@tanstack/react-query";
import { getLeaderboard } from "../api/transcriptions";

// Top 10 people by average call sentiment over the last 30 days
export function useLeaderboard() {
  return useQuery(["leaderboard"], getLeaderboard, {
    select: (res) => res.data?.data ?? [],
    staleTime: 60000,
  });
}
